export default __webpack_public_path__ + "static/media/right-arrow.c813a414.svg";